var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9097 10C17.4346 10 17.6974 10.5678 17.3263 10.8999L12.9166 14.8456C12.6865 15.0515 12.3135 15.0515 12.0834 14.8456L7.67373 10.8999C7.30261 10.5678 7.56545 10 8.0903 10L16.9097 10Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriDown);
export default __webpack_public_path__ + "static/media/tri-down.678c214642e1b4b7a8e6a434bb389dd5.svg";
export { ForwardRef as ReactComponent };